<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="customer_no" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="first_name" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="last_name" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="company_name" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="email" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="address_info" :label="false" :placeholder="true"/>
            </div>

            <div class="input-wrapper">
              <input-widget :model="searchModel" :label="false" :options="{placeholder: $t('Identity Verification')}"
                            display-field="${item.key}" attribute="identity_verification" type="select2" value-field="value"
                            :items="identityVerificationTypes"/>
            </div>
            <div class="input-wrapper">
              <client-tier-select-input-widget :model="searchModel" attribute="client_tier" :label="false"
                            :options="{placeholder: $t('Client Tier')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="has_unsettled_sold_lots" type="checkbox"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import ClientTierSelectInputWidget from "@/core/widgets/ClientTierSelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('vendors');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "VendorsSearch",
    components: {ClientTierSelectInputWidget, InputWidget},
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
      }),
      ...mapStateGlobal({
        identityVerificationTypes: state => state.identityVerificationTypes,
        clientTierOptions: state => state.clientTierOptions,
      }),
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
